/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import * as coreClient from "@azure/core-client";

export const QueueServiceProperties: coreClient.CompositeMapper = {
  serializedName: "QueueServiceProperties",
  xmlName: "StorageServiceProperties",
  type: {
    name: "Composite",
    className: "QueueServiceProperties",
    modelProperties: {
      queueAnalyticsLogging: {
        serializedName: "Logging",
        xmlName: "Logging",
        type: {
          name: "Composite",
          className: "Logging",
        },
      },
      hourMetrics: {
        serializedName: "HourMetrics",
        xmlName: "HourMetrics",
        type: {
          name: "Composite",
          className: "Metrics",
        },
      },
      minuteMetrics: {
        serializedName: "MinuteMetrics",
        xmlName: "MinuteMetrics",
        type: {
          name: "Composite",
          className: "Metrics",
        },
      },
      cors: {
        serializedName: "Cors",
        xmlName: "Cors",
        xmlIsWrapped: true,
        xmlElementName: "CorsRule",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "CorsRule",
            },
          },
        },
      },
    },
  },
};

export const Logging: coreClient.CompositeMapper = {
  serializedName: "Logging",
  type: {
    name: "Composite",
    className: "Logging",
    modelProperties: {
      version: {
        serializedName: "Version",
        required: true,
        xmlName: "Version",
        type: {
          name: "String",
        },
      },
      deleteProperty: {
        serializedName: "Delete",
        required: true,
        xmlName: "Delete",
        type: {
          name: "Boolean",
        },
      },
      read: {
        serializedName: "Read",
        required: true,
        xmlName: "Read",
        type: {
          name: "Boolean",
        },
      },
      write: {
        serializedName: "Write",
        required: true,
        xmlName: "Write",
        type: {
          name: "Boolean",
        },
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy",
        },
      },
    },
  },
};

export const RetentionPolicy: coreClient.CompositeMapper = {
  serializedName: "RetentionPolicy",
  type: {
    name: "Composite",
    className: "RetentionPolicy",
    modelProperties: {
      enabled: {
        serializedName: "Enabled",
        required: true,
        xmlName: "Enabled",
        type: {
          name: "Boolean",
        },
      },
      days: {
        constraints: {
          InclusiveMinimum: 1,
        },
        serializedName: "Days",
        xmlName: "Days",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const Metrics: coreClient.CompositeMapper = {
  serializedName: "Metrics",
  type: {
    name: "Composite",
    className: "Metrics",
    modelProperties: {
      version: {
        serializedName: "Version",
        xmlName: "Version",
        type: {
          name: "String",
        },
      },
      enabled: {
        serializedName: "Enabled",
        required: true,
        xmlName: "Enabled",
        type: {
          name: "Boolean",
        },
      },
      includeAPIs: {
        serializedName: "IncludeAPIs",
        xmlName: "IncludeAPIs",
        type: {
          name: "Boolean",
        },
      },
      retentionPolicy: {
        serializedName: "RetentionPolicy",
        xmlName: "RetentionPolicy",
        type: {
          name: "Composite",
          className: "RetentionPolicy",
        },
      },
    },
  },
};

export const CorsRule: coreClient.CompositeMapper = {
  serializedName: "CorsRule",
  type: {
    name: "Composite",
    className: "CorsRule",
    modelProperties: {
      allowedOrigins: {
        serializedName: "AllowedOrigins",
        required: true,
        xmlName: "AllowedOrigins",
        type: {
          name: "String",
        },
      },
      allowedMethods: {
        serializedName: "AllowedMethods",
        required: true,
        xmlName: "AllowedMethods",
        type: {
          name: "String",
        },
      },
      allowedHeaders: {
        serializedName: "AllowedHeaders",
        required: true,
        xmlName: "AllowedHeaders",
        type: {
          name: "String",
        },
      },
      exposedHeaders: {
        serializedName: "ExposedHeaders",
        required: true,
        xmlName: "ExposedHeaders",
        type: {
          name: "String",
        },
      },
      maxAgeInSeconds: {
        constraints: {
          InclusiveMinimum: 0,
        },
        serializedName: "MaxAgeInSeconds",
        required: true,
        xmlName: "MaxAgeInSeconds",
        type: {
          name: "Number",
        },
      },
    },
  },
};

export const StorageError: coreClient.CompositeMapper = {
  serializedName: "StorageError",
  type: {
    name: "Composite",
    className: "StorageError",
    modelProperties: {
      message: {
        serializedName: "Message",
        xmlName: "Message",
        type: {
          name: "String",
        },
      },
      code: {
        serializedName: "Code",
        xmlName: "Code",
        type: {
          name: "String",
        },
      },
      authenticationErrorDetail: {
        serializedName: "AuthenticationErrorDetail",
        xmlName: "AuthenticationErrorDetail",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueServiceStatistics: coreClient.CompositeMapper = {
  serializedName: "QueueServiceStatistics",
  xmlName: "StorageServiceStats",
  type: {
    name: "Composite",
    className: "QueueServiceStatistics",
    modelProperties: {
      geoReplication: {
        serializedName: "GeoReplication",
        xmlName: "GeoReplication",
        type: {
          name: "Composite",
          className: "GeoReplication",
        },
      },
    },
  },
};

export const GeoReplication: coreClient.CompositeMapper = {
  serializedName: "GeoReplication",
  type: {
    name: "Composite",
    className: "GeoReplication",
    modelProperties: {
      status: {
        serializedName: "Status",
        required: true,
        xmlName: "Status",
        type: {
          name: "Enum",
          allowedValues: ["live", "bootstrap", "unavailable"],
        },
      },
      lastSyncOn: {
        serializedName: "LastSyncTime",
        required: true,
        xmlName: "LastSyncTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
    },
  },
};

export const KeyInfo: coreClient.CompositeMapper = {
  serializedName: "KeyInfo",
  type: {
    name: "Composite",
    className: "KeyInfo",
    modelProperties: {
      start: {
        serializedName: "Start",
        xmlName: "Start",
        type: {
          name: "String",
        },
      },
      expiry: {
        serializedName: "Expiry",
        required: true,
        xmlName: "Expiry",
        type: {
          name: "String",
        },
      },
      delegatedUserTid: {
        serializedName: "DelegatedUserTid",
        xmlName: "DelegatedUserTid",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const UserDelegationKey: coreClient.CompositeMapper = {
  serializedName: "UserDelegationKey",
  type: {
    name: "Composite",
    className: "UserDelegationKey",
    modelProperties: {
      signedObjectId: {
        serializedName: "SignedOid",
        required: true,
        xmlName: "SignedOid",
        type: {
          name: "String",
        },
      },
      signedTenantId: {
        serializedName: "SignedTid",
        required: true,
        xmlName: "SignedTid",
        type: {
          name: "String",
        },
      },
      signedStartsOn: {
        serializedName: "SignedStart",
        required: true,
        xmlName: "SignedStart",
        type: {
          name: "DateTime",
        },
      },
      signedExpiresOn: {
        serializedName: "SignedExpiry",
        required: true,
        xmlName: "SignedExpiry",
        type: {
          name: "DateTime",
        },
      },
      signedService: {
        serializedName: "SignedService",
        required: true,
        xmlName: "SignedService",
        type: {
          name: "String",
        },
      },
      signedVersion: {
        serializedName: "SignedVersion",
        required: true,
        xmlName: "SignedVersion",
        type: {
          name: "String",
        },
      },
      signedDelegatedUserTenantId: {
        serializedName: "SignedDelegatedUserTid",
        xmlName: "SignedDelegatedUserTid",
        type: {
          name: "String",
        },
      },
      value: {
        serializedName: "Value",
        required: true,
        xmlName: "Value",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ListQueuesSegmentResponse: coreClient.CompositeMapper = {
  serializedName: "ListQueuesSegmentResponse",
  xmlName: "EnumerationResults",
  type: {
    name: "Composite",
    className: "ListQueuesSegmentResponse",
    modelProperties: {
      serviceEndpoint: {
        serializedName: "ServiceEndpoint",
        required: true,
        xmlName: "ServiceEndpoint",
        xmlIsAttribute: true,
        type: {
          name: "String",
        },
      },
      prefix: {
        serializedName: "Prefix",
        required: true,
        xmlName: "Prefix",
        type: {
          name: "String",
        },
      },
      marker: {
        serializedName: "Marker",
        xmlName: "Marker",
        type: {
          name: "String",
        },
      },
      maxPageSize: {
        serializedName: "MaxResults",
        required: true,
        xmlName: "MaxResults",
        type: {
          name: "Number",
        },
      },
      queueItems: {
        serializedName: "QueueItems",
        xmlName: "Queues",
        xmlIsWrapped: true,
        xmlElementName: "Queue",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "QueueItem",
            },
          },
        },
      },
      continuationToken: {
        serializedName: "NextMarker",
        required: true,
        xmlName: "NextMarker",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueItem: coreClient.CompositeMapper = {
  serializedName: "QueueItem",
  xmlName: "Queue",
  type: {
    name: "Composite",
    className: "QueueItem",
    modelProperties: {
      name: {
        serializedName: "Name",
        required: true,
        xmlName: "Name",
        type: {
          name: "String",
        },
      },
      metadata: {
        serializedName: "Metadata",
        xmlName: "Metadata",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
    },
  },
};

export const SignedIdentifier: coreClient.CompositeMapper = {
  serializedName: "SignedIdentifier",
  type: {
    name: "Composite",
    className: "SignedIdentifier",
    modelProperties: {
      id: {
        serializedName: "Id",
        required: true,
        xmlName: "Id",
        type: {
          name: "String",
        },
      },
      accessPolicy: {
        serializedName: "AccessPolicy",
        xmlName: "AccessPolicy",
        type: {
          name: "Composite",
          className: "AccessPolicy",
        },
      },
    },
  },
};

export const AccessPolicy: coreClient.CompositeMapper = {
  serializedName: "AccessPolicy",
  type: {
    name: "Composite",
    className: "AccessPolicy",
    modelProperties: {
      startsOn: {
        serializedName: "Start",
        xmlName: "Start",
        type: {
          name: "String",
        },
      },
      expiresOn: {
        serializedName: "Expiry",
        xmlName: "Expiry",
        type: {
          name: "String",
        },
      },
      permissions: {
        serializedName: "Permission",
        xmlName: "Permission",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const DequeuedMessageItem: coreClient.CompositeMapper = {
  serializedName: "DequeuedMessageItem",
  xmlName: "QueueMessage",
  xmlIsWrapped: true,
  type: {
    name: "Composite",
    className: "DequeuedMessageItem",
    modelProperties: {
      messageId: {
        serializedName: "MessageId",
        required: true,
        xmlName: "MessageId",
        type: {
          name: "String",
        },
      },
      insertedOn: {
        serializedName: "InsertionTime",
        required: true,
        xmlName: "InsertionTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      expiresOn: {
        serializedName: "ExpirationTime",
        required: true,
        xmlName: "ExpirationTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      popReceipt: {
        serializedName: "PopReceipt",
        required: true,
        xmlName: "PopReceipt",
        type: {
          name: "String",
        },
      },
      nextVisibleOn: {
        serializedName: "TimeNextVisible",
        required: true,
        xmlName: "TimeNextVisible",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      dequeueCount: {
        serializedName: "DequeueCount",
        required: true,
        xmlName: "DequeueCount",
        type: {
          name: "Number",
        },
      },
      messageText: {
        serializedName: "MessageText",
        required: true,
        xmlName: "MessageText",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueMessage: coreClient.CompositeMapper = {
  serializedName: "QueueMessage",
  type: {
    name: "Composite",
    className: "QueueMessage",
    modelProperties: {
      messageText: {
        serializedName: "MessageText",
        required: true,
        xmlName: "MessageText",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const EnqueuedMessage: coreClient.CompositeMapper = {
  serializedName: "EnqueuedMessage",
  xmlName: "QueueMessage",
  xmlIsWrapped: true,
  type: {
    name: "Composite",
    className: "EnqueuedMessage",
    modelProperties: {
      messageId: {
        serializedName: "MessageId",
        required: true,
        xmlName: "MessageId",
        type: {
          name: "String",
        },
      },
      insertedOn: {
        serializedName: "InsertionTime",
        required: true,
        xmlName: "InsertionTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      expiresOn: {
        serializedName: "ExpirationTime",
        required: true,
        xmlName: "ExpirationTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      popReceipt: {
        serializedName: "PopReceipt",
        required: true,
        xmlName: "PopReceipt",
        type: {
          name: "String",
        },
      },
      nextVisibleOn: {
        serializedName: "TimeNextVisible",
        required: true,
        xmlName: "TimeNextVisible",
        type: {
          name: "DateTimeRfc1123",
        },
      },
    },
  },
};

export const PeekedMessageItem: coreClient.CompositeMapper = {
  serializedName: "PeekedMessageItem",
  xmlName: "QueueMessage",
  xmlIsWrapped: true,
  type: {
    name: "Composite",
    className: "PeekedMessageItem",
    modelProperties: {
      messageId: {
        serializedName: "MessageId",
        required: true,
        xmlName: "MessageId",
        type: {
          name: "String",
        },
      },
      insertedOn: {
        serializedName: "InsertionTime",
        required: true,
        xmlName: "InsertionTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      expiresOn: {
        serializedName: "ExpirationTime",
        required: true,
        xmlName: "ExpirationTime",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      dequeueCount: {
        serializedName: "DequeueCount",
        required: true,
        xmlName: "DequeueCount",
        type: {
          name: "Number",
        },
      },
      messageText: {
        serializedName: "MessageText",
        required: true,
        xmlName: "MessageText",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ServiceSetPropertiesHeaders: coreClient.CompositeMapper = {
  serializedName: "Service_setPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceSetPropertiesHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ServiceSetPropertiesExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Service_setPropertiesExceptionHeaders",
    type: {
      name: "Composite",
      className: "ServiceSetPropertiesExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceGetPropertiesHeaders: coreClient.CompositeMapper = {
  serializedName: "Service_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetPropertiesHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ServiceGetPropertiesExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Service_getPropertiesExceptionHeaders",
    type: {
      name: "Composite",
      className: "ServiceGetPropertiesExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceGetStatisticsHeaders: coreClient.CompositeMapper = {
  serializedName: "Service_getStatisticsHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetStatisticsHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ServiceGetStatisticsExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Service_getStatisticsExceptionHeaders",
    type: {
      name: "Composite",
      className: "ServiceGetStatisticsExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceGetUserDelegationKeyHeaders: coreClient.CompositeMapper = {
  serializedName: "Service_getUserDelegationKeyHeaders",
  type: {
    name: "Composite",
    className: "ServiceGetUserDelegationKeyHeaders",
    modelProperties: {
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
    },
  },
};

export const ServiceGetUserDelegationKeyExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Service_getUserDelegationKeyExceptionHeaders",
    type: {
      name: "Composite",
      className: "ServiceGetUserDelegationKeyExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const ServiceListQueuesSegmentHeaders: coreClient.CompositeMapper = {
  serializedName: "Service_listQueuesSegmentHeaders",
  type: {
    name: "Composite",
    className: "ServiceListQueuesSegmentHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const ServiceListQueuesSegmentExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Service_listQueuesSegmentExceptionHeaders",
    type: {
      name: "Composite",
      className: "ServiceListQueuesSegmentExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const QueueCreateHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_createHeaders",
  type: {
    name: "Composite",
    className: "QueueCreateHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueCreateExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_createExceptionHeaders",
  type: {
    name: "Composite",
    className: "QueueCreateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueDeleteHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_deleteHeaders",
  type: {
    name: "Composite",
    className: "QueueDeleteHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueDeleteExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "QueueDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueGetPropertiesHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_getPropertiesHeaders",
  type: {
    name: "Composite",
    className: "QueueGetPropertiesHeaders",
    modelProperties: {
      metadata: {
        serializedName: "x-ms-meta",
        headerCollectionPrefix: "x-ms-meta-",
        xmlName: "x-ms-meta",
        type: {
          name: "Dictionary",
          value: { type: { name: "String" } },
        },
      },
      approximateMessagesCount: {
        serializedName: "x-ms-approximate-messages-count",
        xmlName: "x-ms-approximate-messages-count",
        type: {
          name: "Number",
        },
      },
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueGetPropertiesExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_getPropertiesExceptionHeaders",
  type: {
    name: "Composite",
    className: "QueueGetPropertiesExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueSetMetadataHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_setMetadataHeaders",
  type: {
    name: "Composite",
    className: "QueueSetMetadataHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueSetMetadataExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_setMetadataExceptionHeaders",
  type: {
    name: "Composite",
    className: "QueueSetMetadataExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueGetAccessPolicyHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_getAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "QueueGetAccessPolicyHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueGetAccessPolicyExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Queue_getAccessPolicyExceptionHeaders",
    type: {
      name: "Composite",
      className: "QueueGetAccessPolicyExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const QueueSetAccessPolicyHeaders: coreClient.CompositeMapper = {
  serializedName: "Queue_setAccessPolicyHeaders",
  type: {
    name: "Composite",
    className: "QueueSetAccessPolicyHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const QueueSetAccessPolicyExceptionHeaders: coreClient.CompositeMapper =
  {
    serializedName: "Queue_setAccessPolicyExceptionHeaders",
    type: {
      name: "Composite",
      className: "QueueSetAccessPolicyExceptionHeaders",
      modelProperties: {
        errorCode: {
          serializedName: "x-ms-error-code",
          xmlName: "x-ms-error-code",
          type: {
            name: "String",
          },
        },
        clientRequestId: {
          serializedName: "x-ms-client-request-id",
          xmlName: "x-ms-client-request-id",
          type: {
            name: "String",
          },
        },
      },
    },
  };

export const MessagesDequeueHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_dequeueHeaders",
  type: {
    name: "Composite",
    className: "MessagesDequeueHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesDequeueExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_dequeueExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessagesDequeueExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesClearHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_clearHeaders",
  type: {
    name: "Composite",
    className: "MessagesClearHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesClearExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_clearExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessagesClearExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesEnqueueHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_enqueueHeaders",
  type: {
    name: "Composite",
    className: "MessagesEnqueueHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesEnqueueExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_enqueueExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessagesEnqueueExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesPeekHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_peekHeaders",
  type: {
    name: "Composite",
    className: "MessagesPeekHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessagesPeekExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "Messages_peekExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessagesPeekExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessageIdUpdateHeaders: coreClient.CompositeMapper = {
  serializedName: "MessageId_updateHeaders",
  type: {
    name: "Composite",
    className: "MessageIdUpdateHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      popReceipt: {
        serializedName: "x-ms-popreceipt",
        xmlName: "x-ms-popreceipt",
        type: {
          name: "String",
        },
      },
      nextVisibleOn: {
        serializedName: "x-ms-time-next-visible",
        xmlName: "x-ms-time-next-visible",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessageIdUpdateExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "MessageId_updateExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessageIdUpdateExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessageIdDeleteHeaders: coreClient.CompositeMapper = {
  serializedName: "MessageId_deleteHeaders",
  type: {
    name: "Composite",
    className: "MessageIdDeleteHeaders",
    modelProperties: {
      requestId: {
        serializedName: "x-ms-request-id",
        xmlName: "x-ms-request-id",
        type: {
          name: "String",
        },
      },
      version: {
        serializedName: "x-ms-version",
        xmlName: "x-ms-version",
        type: {
          name: "String",
        },
      },
      date: {
        serializedName: "date",
        xmlName: "date",
        type: {
          name: "DateTimeRfc1123",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
    },
  },
};

export const MessageIdDeleteExceptionHeaders: coreClient.CompositeMapper = {
  serializedName: "MessageId_deleteExceptionHeaders",
  type: {
    name: "Composite",
    className: "MessageIdDeleteExceptionHeaders",
    modelProperties: {
      errorCode: {
        serializedName: "x-ms-error-code",
        xmlName: "x-ms-error-code",
        type: {
          name: "String",
        },
      },
      clientRequestId: {
        serializedName: "x-ms-client-request-id",
        xmlName: "x-ms-client-request-id",
        type: {
          name: "String",
        },
      },
    },
  },
};
